import React, { LabelHTMLAttributes, ReactNode } from 'react';
import classNames from 'classnames';
import { componentSizeVariantsEnum } from 'src/constants/common.constants';

type TLabel2Props = {
  children: ReactNode;
  variant?: componentSizeVariantsEnum;
  required?: boolean;
} & LabelHTMLAttributes<HTMLLabelElement>;

const Label2 = ({
  children,
  variant = componentSizeVariantsEnum.MEDIUM,
  required = false,
  className,
  ...rest
}: TLabel2Props) => {
  return (
    <label
      className={classNames(
        'label-component-v2',
        `label-component-v2--${variant}`,
        className
      )}
      {...rest}
    >
      {children}
      {required && <span className="required-asterisk-v2">*</span>}
    </label>
  );
};

export default Label2;
